/**
 * Configuration centralisée pour les images statiques
 * Améliore la maintenance et la cohérence des chemins d'images
 */

export const STATIC_IMAGES = {
  // Images principales du booklet

  // Images de base
  UIC_LOGO: "uic_logo.svg",
  APP_LOGO: "sustainability-hub_green",
  HOME_FEATURED_IMAGE: "images/sustainability-solution.webp",

  // Dossiers
  THEMES_DIR: "/images/themes/",
  ICONS_DIR: "/icons/",
  LOGOS_DIR: "/images/logos/",
} as const

/**
 * Obtient le chemin d'une image depuis le dossier public
 * Pour les images qui ne sont pas dans le dossier /images/
 */
export function getPublicImagePath(imageName: string): string {
  return `/${imageName}`
}
